Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {
    var _this = this,
        API, _API;


    API = {
        register: function(instance, id) {
            var _ref;
            if ((_ref = this._registry) == null) {
                this._registry = {};
            }
            return this._registry[id] = instance;
        },
        unregister: function(instance, id) {
            return delete this._registry[id];
        },
        resetRegistry: function() {
            var controller, key, msg, oldCount, _ref;
            oldCount = this.getRegistrySize();
            _ref = this._registry;
            for (key in _ref) {
                controller = _ref[key];
                controller.region.destroy();
            }
            msg = 'There were ' + oldCount + ' controllers in the registry, there are now ' + (this.getRegistrySize());
            if (this.getRegistrySize() > 0) {
                console.warn(msg, this._registry);
            } else {
                console.log(msg);
            }
        },
        getRegistrySize: function() {
            return _.size(this._registry);
        }
    };

    App.commands.setHandler('register:instance', function(instance, id) {
        if (gon.global.env === 'development') {
            return API.register(instance, id);
        }
    });
    App.commands.setHandler('unregister:instance', function(instance, id) {
        if (gon.global.env === 'development') {
            return API.unregister(instance, id);
        }
    });
    App.reqres.setHandler('reset:registry', function() {
        return API.resetRegistry();
    });


});
